import { sharing } from "@microsoft/teams-js";
import { trace } from "owa-trace";

export interface ShareAppOptions {
    url: string;
    message?: string;
    preview?: boolean;
}

/**
 * Opens the Teams share dialog so the user can share a URL (e.g. the Shifts app)
 * into a Teams chat or channel. Wraps `microsoftTeams.sharing.shareWebContent`.
 *
 * Returns `false` if the host doesn't support the sharing capability or the
 * share call fails; returns `true` once the dialog has been dismissed.
 */
export async function shareAppToTeams(options: ShareAppOptions): Promise<boolean> {
    if (!sharing.isSupported()) {
        trace.warn("ShareAppService: sharing capability not supported by host");
        return false;
    }

    try {
        await sharing.shareWebContent({
            content: [
                {
                    type: "URL",
                    url: options.url,
                    message: options.message,
                    preview: options.preview ?? true
                }
            ]
        });
        return true;
    } catch (error) {
        trace.warn(`ShareAppService: shareWebContent failed: ${error}`);
        return false;
    }
}

export default shareAppToTeams;
